import { IconButton, IconClose, Input, Button } from 'cdk-radial';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    StyledPanelHeader,
    StyledPanelHeaderContainer,
    StyledSidePanelContainer,
    FocusWrapperIcon,
    StyledPanelButtonContainer
} from './../../common/StyledComponents'
import { BUTTON_VARIANTS } from '../../common/constants';
import { useAppState } from '../../store/appState';
import { partItem } from '../../common/types';
import SearchableDropdown from '../../common/SearchableDropdown';
import { CDK_VDI_FLAG } from '../../common/staticData';

const EditPartOrder = (
    props: any)
    : JSX.Element => {
    const refClose = useRef<HTMLInputElement>(null);
    const { setPanelCollapsed } = useAppState();
    const [serialNumber, setSerialNumber] = useState<string>('');
    const [vin, setVin] = useState<string>('');
    const [pdc, setPdc] = useState<string>('');
    const [getVdiFlag, setGetVDIFlag] = useState({
        vdiFlag: { label: '', value: '' }
    });
    const [otherCustomerName, setOtherCustomerName] = useState<String>('');
    const [getCustomerName, setCustomerName] = useState({
        customerName: { label: '', value: '' }
    });
    const customerNameData: any = props.dropDownData
        .filter((item: any) => item.name === "CustomerNames")
        .map((item: any) => item.data)[0] || [];

    const [error, setError] = useState<string>('');
    const [cusNameError, setCusNameError] = useState<string>('');

    // VIN validation regex
    const vinRegex = /^(?!00000)(?!.*999999$)(?!.*XXXXX)[A-HJ-NPR-Z0-9]{8}[0-9X][A-HJ-NPR-Z0-9]{8}$/;

    // Validate VIN
 
    useEffect(() => {        
            handleVinChange(vin);    
             validateFields();
         }, [getVdiFlag.vdiFlag.value,getCustomerName?.customerName?.value,vin]);   
    

    const onVinInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        handleVinChange(event.target.value);
    };

    // Handle vin input change  
    const handleVinChange = (value: string): void => {
        setVin(value);
    
        // Error handling and validation in one place
        if (getVdiFlag.vdiFlag.value === 'Yes') {
            if (value.length === 0) {
                setError('VIN is Mandatory');
            } else if (!vinRegex.test(value)) {
                setError('Invalid VIN format. Please check the input.');
            } else {
                setError('');
            }
        } else {
            // If VDI flag is not 'Yes', VIN is not mandatory
            if (value.length === 0) {
                setError('');  // Clear error if VIN is empty
            } else if (!vinRegex.test(value)) {
                setError('Invalid VIN format. Please check the input.');
            } else {
                setError('');  // Clear error if VIN is valid
            }
        }
    };


    useEffect(() => {
        try {
            // Check if props and props.selectedRows are defined
            if (props.header === 'Edit Order Item' && props?.editedRows) {
                const firstRow = props.editedRows;

                // Set state with error checking
                setSerialNumber(firstRow.serialNumber || '');
                setVin(firstRow.vin || '');
                setGetVDIFlag(prevState => ({
                    vdiFlag: { label: firstRow.vdiFlag =='X' ? "Yes" :"", value: firstRow.vdiFlag =='X' ? "Yes" :"" }
                }));
                setPdc(firstRow.pdc || '');
                setCustomerName(prevState => ({
                    customerName: { label: firstRow.dtnaCustomerName, value: firstRow.dtnaCustomerName }
                }));
                setOtherCustomerName(firstRow.dtnaOtherCustomerName || '');
            } else {
                // Handle cases where props.selectedRows.partItem is undefined or null
                console.warn('No partItem found in selectedRows');
                // Optionally, reset state to default values or handle as needed
                setSerialNumber('');
                setVin('');
                setGetVDIFlag(prevState => ({
                    vdiFlag: { label: '', value: '' }
                }));
                setPdc('');
                setCustomerName(prevState => ({
                    customerName: { label: '', value: '' }
                }));
                setOtherCustomerName('');
            }
        } catch (error) {
            // Handle unexpected errors
            console.error('Error in useEffect:', error);
        }
    }, [props.editedRows]);





    const handleBulkSave = () => {

        if (error.length == 0 && cusNameError.length == 0) {

            const updatedRows = props.checkRows.map((row: partItem) => ({
                ...row,
                serialNumber: serialNumber,
                vin: vin,
                pdc: pdc,
                vdiFlag:  (getVdiFlag.vdiFlag.label === 'Yes') ? 'X' : "",
                dtnaCustomerName: getCustomerName.customerName.value
            }));

            const updatedOrders = props.selectedOrders.map((order: any) => ({
                ...order,
                partsEipResponseDTOS: order.partsEipResponseDTOS.map((parts: any) => {
                    const updatedItem = updatedRows.find((item: any) => (item.orderNumber === order.orderNumber && item.partNumber === parts.partNumber));
                    if (updatedItem) {
                        return {
                            ...parts,
                            serialNumber: serialNumber,
                            vin: vin,
                            pdc: pdc,
                            vdiFlag:  (getVdiFlag.vdiFlag.label === 'Yes') ? 'X' : "",
                            dtnaCustomerName: getCustomerName.customerName.label,
                            ...(getCustomerName.customerName.label === "OTHERS" && {
                                dtnaOtherCustomerName: otherCustomerName
                            })
                        }
                    }
                    return parts;

                }),
            }));

            props.setSelectedOrders(updatedOrders);
            props.onClick();
        }
    }

    const validateFields = () => {
        let errorMessage = '';  // Temporary error message to avoid race conditions
    
        if ((getVdiFlag?.vdiFlag?.value === 'Yes' || getVdiFlag?.vdiFlag?.value === 'X') 
            && !getCustomerName?.customerName?.value) {
            errorMessage = 'Customer Name is mandatory';
        } 
        if (getCustomerName?.customerName?.value === "OTHERS" && otherCustomerName.trim().length === 0) {
            errorMessage = 'Customer Name Input is mandatory if Others is selected';
        }
    
        setCusNameError(errorMessage);
    };
    
    


    const handleSave = () => {
        validateFields();

        if (error.length == 0 && cusNameError.length == 0) {

            const updatedItem = { ...props.editedRows, serialNumber, vin, pdc, vdiFlag: getVdiFlag.vdiFlag.label, dtnaCustomerName: getCustomerName.customerName.label };
            const updatedOrders = props.selectedOrders.map((order: any) => ({
                ...order,
                partsEipResponseDTOS: order.partsEipResponseDTOS.map((parts: any) =>
                    parts.partNumber === updatedItem.partNumber && updatedItem.orderLine === parts.orderLine  && parts.orderQty === updatedItem.orderQty
                        ? {
                            ...parts,
                            serialNumber: serialNumber || updatedItem.serialNumber,
                            vin: vin || updatedItem.vin,
                            pdc: pdc || updatedItem.pdc,
                            vdiFlag: (getVdiFlag.vdiFlag.label === 'Yes') ? 'X' : "" ,
                            dtnaCustomerName: getCustomerName.customerName.label || updatedItem.dtnaCustomerName,
                            ...(getCustomerName.customerName.label === "OTHERS" && {
                                dtnaOtherCustomerName: otherCustomerName
                            })
                        }
                        : parts
                ),
            }));

            props.setSelectedOrders(updatedOrders);
            props.onClick();
        }
    }



    const resetFields = () => {
        setSerialNumber('');
        setVin('');
        setPdc('');
        setGetVDIFlag(prevState => ({
            vdiFlag: { label: '', value: '' }
        }));
        setPanelCollapsed(true);

    }

    return (
        <StyledSidePanelContainer>
            <StyledPanelHeaderContainer>
                <StyledPanelHeader>
                    {props.header}
                </StyledPanelHeader>
                <FocusWrapperIcon style={{ padding: "2% 1% 3% 2%" }}>
                    <IconButton
                        data-testid="side-sheet-inline-close"
                        icon={<IconClose style={{ fill: "white" }} />}
                        size='small'
                        text="Button"
                        onClick={() => setPanelCollapsed(true)}
                        ref={refClose}
                    />
                </FocusWrapperIcon>
            </StyledPanelHeaderContainer>
            <div></div>
            <div style={{ overflow: "auto", padding: "10px 2px 10px 10px" }}>


                <SearchableDropdown
                    id="input-VDI-Flag"
                    label="VDI Flag"
                    defaultOptions={CDK_VDI_FLAG}
                    setSelectedOption={(option: any) => {
                        setGetVDIFlag(prevState => ({
                            vdiFlag: option
                        }));
                        
                    }}
                    selectedOption={getVdiFlag.vdiFlag}
                    isRequired={true}
                    placeHolder={'Select CDK Order Type'}
                    hasClearButton={true}   
                    onInputClear={() => {
                        setGetVDIFlag({ vdiFlag: { label: '', value: '' } }); 

                    }}                                                            
                />
            </div>


            <div style={{ overflow: "auto", padding: "20px 10px 10px 10px" }}>
                <div style={{ display: "flex" }}>
                    <Input
                        dataTestId="test-serial-number-input"
                        hideBorder="none"
                        iconPosition="trailing"
                        id="order-number-input"
                        inputDivider="left"
                        label="Serial Number"
                        name="Serial-Number"
                        placeholder="Serial Number"
                        size="standard"
                        isRequired={false}
                        hasClearButton={false}
                        onChange={(event: any) => {
                            setSerialNumber(event.target.value)
                        }}
                        value={serialNumber}
                        isDisabled={false}
                        maxLength={25}
                    />
                </div>

            </div>


            <div style={{ overflow: "auto", padding: "10px 10px 10px 10px" }}>
                <div style={{ display: "flex" }}>

                    <Input
                        dataTestId="test-vin-input"
                        hideBorder="none"
                        iconPosition="trailing"
                        id="order-number-input"
                        inputDivider="left"
                        label="VIN"
                        name="VIN"
                        placeholder=""
                        size="standard"
                        isRequired={
                        getVdiFlag.vdiFlag.value === 'Yes' ? true : false
                        }
                        hasClearButton={true}
                        onInputClear={() => {
                        setVin("");
                         }}    
                        onChange={onVinInputChange}
                        value={vin}
                        isDisabled={false}
                        maxLength={17}
                    />
                </div>
                {error && <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>}
            </div>




            <div style={{ overflow: "auto", padding: "10px 2px 10px 10px" }}>


                <SearchableDropdown
                    id="input-Customer-Name"
                    label="Customer Name"
                    defaultOptions={customerNameData}
                    setSelectedOption={(option: any) => {
                        setCustomerName(prevState => ({
                            customerName: option
                        }));
                    }}
                    selectedOption={getCustomerName.customerName}
                     isRequired={
                        getVdiFlag.vdiFlag.value === 'Yes' ? true : false
                      }
                    placeHolder={'Select Customer Name'}
                    hasClearButton={false}
                    
                />
                 {cusNameError && getCustomerName.customerName?.value !== 'OTHERS'  && <span style={{ color: 'red', fontSize: '12px' }}>{cusNameError}</span>}
             </div>
            {getCustomerName.customerName?.value === 'OTHERS' && (
                <div style={{ overflow: "auto", padding: "10px 10px 10px 10px" }}>
                    <div>

                        <Input
                            dataTestId="test-other-customerName-input"
                            hideBorder="none"
                            iconPosition="trailing"
                            id="CustomerName-input"
                            inputDivider="left"
                            label="Other Customer Name"
                            name="Other  Name"
                            placeholder=""
                            size="standard"
                            isRequired={false}
                            hasClearButton={true}
                            onChange={(event: any) => {
                                setOtherCustomerName(event.target.value)
                            }}
                            value={otherCustomerName}
                            isDisabled={false}
                            maxLength={25}
                        />
                    </div>
                    {cusNameError && <span style={{ color: 'red', fontSize: '12px' }}>{cusNameError}</span>}
                </div>
            )}

            <div style={{ overflow: "auto", padding: "10px 10px 10px 10px" }}>
                <div style={{ display: "flex" }}>
                    <Input
                        dataTestId="test-pdc-input"
                        hideBorder="none"
                        iconPosition="trailing"
                        id="pdc-input"
                        inputDivider="left"
                        label="Part Distribution Center Code"
                        name="Part Distribution Center Code"
                        placeholder=""
                        size="standard"
                        isRequired={false}
                        hasClearButton={false}
                        onChange={(event: any) => {
                            setPdc(event.target.value)
                        }}
                        value={pdc}
                        isDisabled={false}
                        maxLength={4}
                    />
                </div>

            </div>
            <StyledPanelButtonContainer>
                {props.singleEdit ? (
                    <Button
                        text={
                            <FormattedMessage
                                defaultMessage="Save"
                                description="Save"
                            />
                        }
                        variant={BUTTON_VARIANTS.PRIMARY}
                        onClick={handleSave}

                    />) : (
                    <Button
                        text={
                            <FormattedMessage
                                defaultMessage="Save"
                                description="Save"
                            />
                        }
                        variant={BUTTON_VARIANTS.PRIMARY}
                        onClick={handleBulkSave}

                    />)}

                <Button
                    text={<FormattedMessage defaultMessage="Cancel" description="Cancel" />}
                    variant={BUTTON_VARIANTS.SECONDARY}
                    size="standard"
                    style={{ marginLeft: "1%" }}
                    onClick={resetFields}

                />

            </StyledPanelButtonContainer>

        </StyledSidePanelContainer >
    );
};

export default EditPartOrder;
